export default function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-array/src/descending.js
// module id = znGa
// module chunks = 0